const rotate = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
    <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6.375 17.625 5.625 17.625 5.625 16.875"/>
      <polyline points="16.875 17.625 17.625 17.625 17.625 16.875"/>
      <line x1="8.625" x2="7.875" y1="17.625" y2="17.625"/>
      <line x1="10.875" x2="10.125" y1="17.625" y2="17.625"/>
      <line x1="13.125" x2="12.375" y1="17.625" y2="17.625"/>
      <line x1="15.375" x2="14.625" y1="17.625" y2="17.625"/>
      <polyline points="16.875 10.125 17.625 10.125 17.625 10.875"/>
      <line x1="8.625" x2="7.875" y1="10.125" y2="10.125"/>
      <line x1="10.875" x2="10.125" y1="10.125" y2="10.125"/>
      <line x1="13.125" x2="12.375" y1="10.125" y2="10.125"/>
      <line x1="15.375" x2="14.625" y1="10.125" y2="10.125"/>
      <line x1="17.625" x2="17.625" y1="12.375" y2="13.125"/>
      <line x1="17.625" x2="17.625" y1="14.625" y2="15.375"/>
      <line x1="5.625" x2="5.625" y1="12.375" y2="13.125"/>
      <line x1="5.625" x2="5.625" y1="14.625" y2="15.375"/>
      <rect width="7.5" height="12" x=".375" y=".375"/>
      <g transform="translate(9)">
        <path d="M6.375,8.625 L6.375,5.625 C6.375,3.969 5.03175,2.625 3.375,2.625 L0.37275,2.625"/>
        <polyline points="2.623 .375 .373 2.625 2.623 4.875"/>
        <polyline points="8.625 6.375 6.375 8.625 4.125 6.375"/>
      </g>
    </g>
    <rect width="18" height="18"/>
  </g>
</svg>

`;

export default rotate;
